/* ==========================================================================
   Luxurdo — gemeinsames Verhalten aller lux-Sections.
   Wird von jeder Section eingebunden; initialisiert sich nur einmal.
   Keine externe Bibliothek, kein GSAP, kein Lenis.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__luxInit) return;
  window.__luxInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var onFine = window.matchMedia('(pointer: fine)');

  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ----------------------------------------------------------------------
     1 · Medien-Slot: Ton-Umschalter, Play-Button, reduced motion
     ---------------------------------------------------------------------- */

  function slotVideo(slot) { return slot.querySelector('video'); }

  function applyReducedMotionToMedia() {
    if (!reduce.matches) return;
    $$('[data-lx-media][data-lx-autoplay="true"]').forEach(function (slot) {
      var v = slotVideo(slot);
      if (!v) return;
      v.autoplay = false;
      v.removeAttribute('autoplay');
      v.pause();
      if (slot.querySelector('[data-lx-play]')) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lux-media__play';
      b.setAttribute('data-lx-play', '');
      b.setAttribute('aria-label', 'Video abspielen');
      b.innerHTML = '<span aria-hidden="true">&#9654;</span>';
      slot.appendChild(b);
    });
  }

  document.addEventListener('click', function (e) {
    var play = e.target.closest && e.target.closest('[data-lx-play]');
    if (play) {
      var slot = play.closest('[data-lx-media]');
      var v = slot && slotVideo(slot);
      if (v) {
        if (slot.querySelector('[data-lx-sound]')) v.muted = false;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
      play.remove();
      return;
    }

    var snd = e.target.closest && e.target.closest('[data-lx-sound]');
    if (snd) {
      var s = snd.closest('[data-lx-media]');
      var sv = s && slotVideo(s);
      if (!sv) return;
      sv.muted = !sv.muted;
      snd.setAttribute('aria-pressed', String(!sv.muted));
      snd.setAttribute('aria-label', sv.muted ? 'Ton einschalten' : 'Ton ausschalten');
      var icon = snd.querySelector('[data-lx-sound-icon]');
      if (icon) icon.innerHTML = sv.muted ? '&#128263;' : '&#128266;';
    }
  });

  /* ----------------------------------------------------------------------
     2 · Buy Box: Galerie, Bundle-Auswahl, Add-ons, Sticky ATC
     ---------------------------------------------------------------------- */

  function initBuybox(root) {
    // Galerie — Thumbnail wechselt das Hauptbild
    var main = root.querySelector('[data-lx-gallery-main]');
    $$('[data-lx-thumb]', root).forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-src');
        var img = main && main.querySelector('img');
        if (src && img) { img.src = src; img.srcset = ''; }
        $$('[data-lx-thumb]', root).forEach(function (o) { o.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });

    // Bundle-Staffel — steuert die Menge und den angezeigten Preis
    var qtyInput = root.querySelector('[data-lx-qty]');
    var priceOuts = $$('[data-lx-price-out]', root);
    var compareOuts = $$('[data-lx-compare-out]', root);
    var saveOuts = $$('[data-lx-save-out]', root);

    // Preis-Strings sind vom Haendler getippt und bereits formatiert.
    // Wir rechnen nur fuer die Ersparnis und uebernehmen das Format des Preises.
    function luxParseMoney(str) {
      if (!str) return NaN;
      var m = String(str).replace(/[^0-9.,]/g, '');
      if (!m) return NaN;
      if (/,\d{1,2}$/.test(m) && !/\.\d{1,2}$/.test(m)) m = m.replace(/\./g, '').replace(',', '.');
      else m = m.replace(/,/g, '');
      var n = parseFloat(m);
      return isFinite(n) ? n : NaN;
    }
    function luxFormatLike(sample, value) {
      var str = String(sample || '');
      var pre = (str.match(/^[^0-9]*/) || [''])[0];
      var post = (str.match(/[^0-9]*$/) || [''])[0];
      var num = (str.match(/[0-9][0-9.,]*/) || [''])[0];
      var out = value.toFixed(2);
      if (/,\d{1,2}$/.test(num)) out = out.replace('.', ',');
      return pre + out + post;
    }
    function luxUpdatePrice(card) {
      var label = card.getAttribute('data-price-label') || '';
      if (label) priceOuts.forEach(function (el) { el.textContent = label; });

      var cmpEl = card.querySelector('.lux-bb__strike');
      var cmpTxt = cmpEl ? cmpEl.textContent.trim() : '';
      compareOuts.forEach(function (el) {
        el.textContent = cmpTxt;
        el.style.display = cmpTxt ? '' : 'none';
      });

      var cur = luxParseMoney(label);
      var cmp = luxParseMoney(cmpTxt);
      saveOuts.forEach(function (el) {
        if (!isFinite(cur) || !isFinite(cmp) || cmp <= cur) { el.textContent = ''; el.style.display = 'none'; return; }
        var pre = el.getAttribute('data-lx-save-prefix') || '';
        el.style.display = '';
        el.textContent = el.getAttribute('data-lx-save-mode') === 'percent'
          ? pre + Math.round((cmp - cur) / cmp * 100) + '%'
          : pre + luxFormatLike(label, cmp - cur);
      });
    }

    $$('[data-lx-bundle]', root).forEach(function (card) {
      card.addEventListener('click', function () {
        $$('[data-lx-bundle]', root).forEach(function (o) {
          o.setAttribute('aria-checked', 'false');
          o.classList.remove('is-active');
        });
        card.setAttribute('aria-checked', 'true');
        card.classList.add('is-active');
        if (qtyInput) qtyInput.value = card.getAttribute('data-qty') || '1';
        luxUpdatePrice(card);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); card.click(); }
      });
    });

    // Add-ons ein-/ausklappen — je Container einer, damit mehrere Laeufe funktionieren
    $$('[data-lx-addons-toggle]', root).forEach(function (toggle) {
      var scope = (toggle.closest && toggle.closest('.lux-bb__addons')) || root;
      var extra = scope.querySelector('[data-lx-addons-extra]');
      if (!extra) return;
      toggle.addEventListener('click', function () {
        var open = extra.hasAttribute('hidden');
        if (open) extra.removeAttribute('hidden'); else extra.setAttribute('hidden', '');
        toggle.textContent = open
          ? (toggle.getAttribute('data-label-less') || 'Show less −')
          : (toggle.getAttribute('data-label-more') || 'All add-ons +');
        toggle.setAttribute('aria-expanded', String(open));
      });
    });

    // Sticky Quick-Add — erscheint, sobald die Galerie verlassen wird
    var sticky = root.querySelector('[data-lx-sticky]');
    var anchor = root.querySelector('[data-lx-sticky-anchor]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
        });
      }, { threshold: 0 }).observe(anchor);
    }
  }

  /* ----------------------------------------------------------------------
     3 · Timeline (S14) — Sticky-Scrub: vertikales Scrollen schiebt horizontal
     ---------------------------------------------------------------------- */

  function initTimeline(root) {
    var scroller = root.querySelector('[data-lx-tl-scroller]');
    var track = root.querySelector('[data-lx-tl-track]');
    if (!scroller || !track) return;
    if (track.__luxTl) return;
    track.__luxTl = true;

    var nodes = $$('[data-lx-tl-node]', track);
    var cards = $$('[data-lx-tl-card]', track);
    var items = nodes.concat(cards);
    var infinite = root.getAttribute('data-infinite') === 'true';
    var linked = root.getAttribute('data-scroll-link') === 'true' && !reduce.matches;
    var speed = parseFloat(root.getAttribute('data-scroll-speed') || '100') / 100;
    var dir = root.getAttribute('data-scroll-direction') === 'reverse' ? -1 : 1;

    // Geometrie einmal pro Layout messen, nie pro Frame. Jeder Zugriff auf
    // scrollWidth oder offsetLeft erzwingt eine Neuberechnung des Layouts —
    // im Frame waere das die Hauptquelle des Ruckelns.
    var unit = 0, fullW = 0, viewW = 0, centers = [], snaps = [];
    function measure() {
      fullW = track.scrollWidth;
      viewW = scroller.clientWidth;
      unit = infinite ? fullW / 3 : 0;
      var padL = parseFloat(getComputedStyle(scroller).scrollPaddingLeft) || 0;
      // offsetLeft zaehlt ab dem Track, scrollLeft ab dem Scroller — der
      // Versatz des Tracks gehoert dazwischen, sonst rastet es daneben ein.
      var base = track.offsetLeft;
      centers = items.map(function (el) { return base + el.offsetLeft + el.offsetWidth / 2; });
      snaps = cards.map(function (el) { return base + el.offsetLeft - padL; });
    }

    // Position wird vom Skript gefuehrt, nicht aus dem DOM zurueckgelesen.
    var pos = 0;
    var settleTo = null;
    var rafId = 0;
    var pageDirty = false;
    var last = null;
    var idleT = 0;
    var dragging = false;

    // CSS-Snapping und programmatisches Scrollen schliessen einander aus:
    // ein Snap-Punkt zieht jeden Teilschritt sofort zurueck. Waehrend das
    // Skript schiebt, ist Snapping daher aus und rastet danach weich ein.
    function snapOff() { if (scroller.style.scrollSnapType !== 'none') scroller.style.scrollSnapType = 'none'; }
    function snapOn() { if (scroller.style.scrollSnapType) scroller.style.scrollSnapType = ''; }

    // Der Umschlag der Schleife verschiebt um genau eine Wiederholeinheit.
    // Die Einheit umfasst eine ganze Zahl an Kartenplaetzen, Hoehe und
    // Steigung der Welle treffen sich exakt — der Sprung ist unsichtbar.
    function wrap(p) {
      if (!infinite || unit <= 0) return p;
      while (p < unit * 0.5) p += unit;
      while (p >= unit * 1.5) p -= unit;
      return p;
    }

    function write(p) {
      var q = wrap(p);
      if (settleTo !== null) settleTo += q - p;
      pos = q;
      scroller.scrollLeft = q;
    }

    function kick() { if (!rafId) rafId = requestAnimationFrame(frame); }

    function paint() {
      var left = pos, right = pos + viewW;
      for (var i = 0; i < items.length; i++) {
        var c = centers[i];
        var on = c >= left - 40 && c <= right + 40;
        if (items[i].__luxOn !== on) {
          items[i].__luxOn = on;
          items[i].classList.toggle('is-active', on);
        }
      }
    }

    function frame() {
      rafId = 0;

      if (pageDirty) {
        pageDirty = false;
        var r = root.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) {
          last = null;
        } else {
          var prog = (window.innerHeight - r.top) / (r.height + window.innerHeight); // 0..1
          if (last === null) {
            last = prog;
          } else {
            // Als Differenz anwenden, nicht absolut — so bleibt manuelles
            // Wischen erhalten und die Kopplung traegt ueber den Umschlag.
            var span = unit > 0 ? unit : Math.max(0, fullW - viewW);
            var delta = (prog - last) * span * 2 * speed * dir;
            last = prog;
            if (delta) write(pos + delta);
          }
        }
      }

      if (settleTo !== null) {
        var d = settleTo - pos;
        if (Math.abs(d) < 0.5) { write(settleTo); settleTo = null; snapOn(); }
        else { write(pos + d * 0.22); kick(); }
      }

      paint();
    }

    // Nach dem Ausrollen auf den naechsten Kartenanfang zurechtruecken und
    // erst dann das CSS-Snapping wieder zulassen — sonst springt es sichtbar.
    function settle() {
      if (dragging || !snaps.length) { snapOn(); return; }
      var best = null, bd = Infinity;
      for (var i = 0; i < snaps.length; i++) {
        var d = Math.abs(snaps[i] - pos);
        if (d < bd) { bd = d; best = snaps[i]; }
      }
      if (best === null || bd < 0.5) { snapOn(); return; }
      settleTo = best;
      kick();
    }

    if (linked) {
      window.addEventListener('scroll', function () {
        pageDirty = true;
        settleTo = null;
        snapOff();
        clearTimeout(idleT);
        idleT = setTimeout(settle, 160);
        kick();
      }, { passive: true });
    }

    // Native Wischgesten und Mausrad laufen ohne uns; hier nur die eigene
    // Position nachfuehren und den Umschlag setzen.
    scroller.addEventListener('scroll', function () {
      var sl = scroller.scrollLeft;
      if (Math.abs(sl - pos) > 1) {
        pos = sl;
        if (infinite && unit > 0 && (pos < unit * 0.5 || pos >= unit * 1.5)) write(pos);
      }
      kick();
    }, { passive: true });

    // Ziehen mit der Maus. Auf Touch scrollt der Container selbst — dort
    // zusaetzlich zu schreiben hiesse, die Bewegung doppelt anzuwenden.
    var startX = 0, startL = 0;
    scroller.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      dragging = true; startX = e.clientX; startL = pos;
      snapOff();
      clearTimeout(idleT);
      scroller.style.cursor = 'grabbing';
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      write(startL - (e.clientX - startX));
      kick();
    }, { passive: true });
    window.addEventListener('pointerup', function () {
      if (!dragging) return;
      dragging = false;
      scroller.style.cursor = '';
      settle();
    });

    function relayout() {
      var before = unit > 0 ? pos / unit : 0;
      measure();
      if (unit > 0) write(before * unit); else paint();
      paint();
    }

    function start() {
      measure();
      write(unit > 0 ? unit : 0);
      paint();
    }

    start();
    if (document.readyState !== 'complete') window.addEventListener('load', start);
    var rt = 0;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(relayout, 150); });
  }

  /* ----------------------------------------------------------------------
     4 · Wort-Overlay (S04) — zwei Geschwindigkeiten beim Scrollen
     ---------------------------------------------------------------------- */

  function initParallax(root) {
    if (reduce.matches) return;
    var words = $$('[data-lx-parallax]', root);
    if (!words.length) return;

    var ticking = false;
    function frame() {
      ticking = false;
      var rect = root.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      var p = (window.innerHeight - rect.top) / (window.innerHeight + rect.height); // 0..1
      words.forEach(function (w) {
        var speed = parseFloat(w.getAttribute('data-lx-parallax')) || 0;
        w.style.transform = 'translate(-50%, -50%) translateY(' + ((p - 0.5) * speed * 100).toFixed(2) + 'px)';
      });
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(frame); }
    }, { passive: true });
    frame();
  }

  /* ----------------------------------------------------------------------
     5 · Frequenz-Welle — „Generate Another" rotiert durch die Satzteile
     ---------------------------------------------------------------------- */

  function initFrequency(root) {
    var btn = root.querySelector('[data-lx-freq-btn]');
    var p1 = root.querySelector('[data-lx-freq-1]');
    var p2 = root.querySelector('[data-lx-freq-2]');
    var data = root.querySelector('[data-lx-freq-data]');
    if (!btn || !p1 || !p2 || !data) return;

    var phrases;
    try { phrases = JSON.parse(data.textContent); } catch (err) { return; }
    if (!phrases || !phrases.length) return;

    var i = 0;
    btn.addEventListener('click', function () {
      i = (i + 1) % phrases.length;
      [p1, p2].forEach(function (el) { el.classList.add('is-out'); });
      window.setTimeout(function () {
        p1.textContent = phrases[i].a;
        p2.textContent = phrases[i].b;
        [p1, p2].forEach(function (el) { el.classList.remove('is-out'); });
      }, reduce.matches ? 0 : 180);

      // Waveform neu anstossen
      var bars = root.querySelector('[data-lx-waveform]');
      if (bars && !reduce.matches) {
        bars.classList.remove('is-running');
        void bars.offsetWidth;
        bars.classList.add('is-running');
      }
    });
  }

  /* ----------------------------------------------------------------------
     6 · Scroll-Reveal — gestaffeltes Fade-Up
     ---------------------------------------------------------------------- */

  function initReveal(root) {
    var items = $$('[data-lx-reveal]', root);
    if (!items.length) return;
    if (reduce.matches || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        var d = parseInt(el.getAttribute('data-lx-reveal'), 10) || 0;
        el.style.transitionDelay = d + 'ms';
        el.classList.add('is-in');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }


  /* ----------------------------------------------------------------------
     7 · Audio — seitenweit laeuft immer nur EINE Spur
     Runde 2, Punkte 3.1 / 6.2
     ---------------------------------------------------------------------- */

  var LuxAudio = (function () {
    var current = null;      // aktuell spielendes <audio>
    var players = [];        // { audio, buttons[] }

    function stopAll(except) {
      players.forEach(function (pl) {
        if (pl.audio === except) return;
        if (!pl.audio.paused) pl.audio.pause();
      });
      // Auch Video-Ton verstummen lassen
      $$('video').forEach(function (v) { if (!v.muted) v.muted = true; });
      syncAll();
    }

    function syncAll() { players.forEach(sync); }

    function sync(pl) {
      var playing = !pl.audio.paused && !pl.audio.ended;
      pl.buttons.forEach(function (b) {
        b.setAttribute('aria-pressed', String(playing));
        b.classList.toggle('is-playing', playing);
        var ic = b.querySelector('[data-lx-audio-icon]');
        if (ic) ic.innerHTML = playing ? '&#10073;&#10073;' : '&#9654;';
        var host = b.closest('[data-lx-audio-host]');
        if (host) host.classList.toggle('is-playing', playing);
      });
    }

    function register(src, loop, buttons) {
      if (!src) return null;
      var found = null;
      players.forEach(function (pl) { if (pl.src === src) found = pl; });
      if (found) {
        buttons.forEach(function (b) { if (found.buttons.indexOf(b) < 0) found.buttons.push(b); });
        return found;
      }
      var a = new Audio();
      a.preload = 'none';            // kein Datenvolumen ohne Klick
      a.src = src;
      a.loop = !!loop;
      a.addEventListener('play', function () { current = a; stopAll(a); syncAll(); });
      a.addEventListener('pause', syncAll);
      a.addEventListener('ended', syncAll);
      var pl = { src: src, audio: a, buttons: buttons.slice() };
      players.push(pl);
      return pl;
    }

    function toggle(pl) {
      if (!pl) return;
      if (pl.audio.paused) {
        stopAll(pl.audio);
        var pr = pl.audio.play();
        if (pr && pr.catch) pr.catch(function () {});
      } else {
        pl.audio.pause();
      }
      sync(pl);
    }

    return { register: register, toggle: toggle, stopAll: stopAll, current: function () { return current; } };
  })();

  window.LuxAudio = LuxAudio;

  function initAudio(root) {
    // Alle Buttons einer Section, die auf dieselbe Quelle zeigen, teilen sich einen Player
    var groups = {};
    $$('[data-lx-audio]', root).forEach(function (btn) {
      var src = btn.getAttribute('data-src');
      if (!src) return;
      (groups[src] = groups[src] || []).push(btn);
    });
    Object.keys(groups).forEach(function (src) {
      var btns = groups[src];
      var loop = btns[0].getAttribute('data-loop') === 'true';
      var pl = LuxAudio.register(src, loop, btns);
      btns.forEach(function (b) {
        if (b.__luxBound) return;
        b.__luxBound = true;
        b.addEventListener('click', function (e) {
          e.preventDefault();
          LuxAudio.toggle(pl);
          var wave = root.querySelector('[data-lx-waveform]');
          if (wave) wave.classList.toggle('is-active', !pl.audio.paused);
          if (!pl.audio.paused) startReactive(root, pl.audio);
        });
      });
    });
  }

  /* ----------------------------------------------------------------------
     8 · Waveform — Zustandswechsel (pulse) oder echte Analyse (reactive)
     Faellt bei fehlender Web Audio API still auf pulse zurueck.
     ---------------------------------------------------------------------- */

  var reactiveWired = new WeakSet();

  function startReactive(root, audioEl) {
    var wave = root.querySelector('[data-lx-waveform]');
    if (!wave || wave.getAttribute('data-mode') !== 'reactive') return;
    if (reduce.matches) return;
    if (reactiveWired.has(audioEl)) return;

    var Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;                       // still auf pulse bleiben

    try {
      var ctx = new Ctx();                  // erst NACH dem Klick erzeugen
      var srcNode = ctx.createMediaElementSource(audioEl);
      var analyser = ctx.createAnalyser();
      analyser.fftSize = 128;
      srcNode.connect(analyser);
      analyser.connect(ctx.destination);
      reactiveWired.add(audioEl);

      var bars = $$('.lux-fq__bar', wave);
      var data = new Uint8Array(analyser.frequencyBinCount);

      wave.classList.add('is-reactive');

      (function frame() {
        if (audioEl.paused) {
          wave.classList.remove('is-reactive');
          bars.forEach(function (b) { b.style.transform = ''; });
          return;
        }
        analyser.getByteFrequencyData(data);
        for (var i = 0; i < bars.length; i++) {
          var v = data[i % data.length] / 255;
          bars[i].style.transform = 'scaleY(' + (0.25 + v * 1.5).toFixed(3) + ')';
        }
        requestAnimationFrame(frame);
      })();
    } catch (err) {
      /* pulse bleibt aktiv — der Besucher merkt nichts */
    }
  }

  /* ----------------------------------------------------------------------
     9 · Videos: nur eines mit Ton, ausserhalb des Sichtfelds pausieren
     Runde 2, Punkt 5.6
     ---------------------------------------------------------------------- */

  function initVideoDiscipline(root) {
    // Ton exklusiv
    $$('[data-lx-sound]', root).forEach(function (btn) {
      if (btn.__luxExclusive) return;
      btn.__luxExclusive = true;
      btn.addEventListener('click', function () {
        var slot = btn.closest('[data-lx-media]');
        var mine = slot && slot.querySelector('video');
        if (!mine || mine.muted) return;
        if (window.LuxAudio) window.LuxAudio.stopAll(null);
        $$('video').forEach(function (v) { if (v !== mine) v.muted = true; });
      });
    });

    // Ausserhalb des Sichtfelds pausieren
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          if (v.dataset.luxWasPlaying === '1') { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        } else if (!v.paused) {
          v.dataset.luxWasPlaying = '1';
          v.pause();
        }
      });
    }, { threshold: 0.1 });
    $$('video', root).forEach(function (v) { io.observe(v); });
  }

  /* ----------------------------------------------------------------------
     11 · Sprachnachricht in der Buy Box — Player, Wellenform, Transkript
     ---------------------------------------------------------------------- */

  function initVoice(root) {
    if (root.__luxVoice) return;
    root.__luxVoice = true;

    // Gemeinsames Register mit der Section lux-voice-notes: es laeuft immer
    // nur eine Aufnahme, egal aus welchem Baustein sie kommt.
    window.luxVnPlayers = window.luxVnPlayers || [];

    function fmt(sec) {
      sec = Math.max(0, Math.floor(sec || 0));
      var m = Math.floor(sec / 60), r = sec % 60;
      return m + ':' + (r < 10 ? '0' : '') + r;
    }

    // Deterministischer Zufall: gleiche Karte, gleiche Wellenform bei jedem Aufruf.
    function mulberry32(a) {
      return function () {
        a |= 0; a = (a + 0x6d2b79f5) | 0;
        var t = Math.imul(a ^ (a >>> 15), 1 | a);
        t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
      };
    }

    function peaks(n, seed) {
      var rnd = mulberry32(seed * 9781 + 17), out = [];
      for (var i = 0; i < n; i++) {
        var env = 0.42 + 0.58 * Math.abs(Math.sin((i / n) * Math.PI * 2.7 + seed));
        out.push(Math.max(0.12, Math.min(1, (0.32 + 0.68 * rnd()) * env)));
      }
      return out;
    }

    function paint(el, vals) {
      var html = '';
      for (var i = 0; i < vals.length; i++) html += '<span style="height:' + (vals[i] * 100).toFixed(1) + '%"></span>';
      el.innerHTML = html;
    }

    $$('[data-lx-voice-card]', root).forEach(function (card) {
      var audio = card.querySelector('[data-lx-voice-audio]');
      var play = card.querySelector('[data-lx-voice-play]');
      var wave = card.querySelector('[data-lx-voice-wave]');
      var base = card.querySelector('[data-lx-voice-base]');
      var fill = card.querySelector('[data-lx-voice-fill]');
      var time = card.querySelector('[data-lx-voice-time]');
      var tbtn = card.querySelector('[data-lx-voice-tbtn]');
      var panel = card.querySelector('[data-lx-voice-panel]');
      var seed = parseInt(card.getAttribute('data-seed') || '1', 10);

      var vals = peaks(44, seed);
      paint(base, vals);
      paint(fill, vals);
      // Timer statt requestAnimationFrame: rAF ruht in Hintergrund-Tabs, die
      // Balken blieben dort sonst dauerhaft zusammengeschoben stehen.
      setTimeout(function () { card.classList.add('is-drawn'); }, 30);

      function progress(ratio) {
        var p = Math.max(0, Math.min(1, ratio || 0));
        fill.style.clipPath = 'inset(0 ' + ((1 - p) * 100).toFixed(2) + '% 0 0)';
      }

      function tick() {
        if (!audio) return;
        time.textContent = fmt(audio.currentTime);
        if (isFinite(audio.duration) && audio.duration > 0) progress(audio.currentTime / audio.duration);
      }

      if (audio) {
        window.luxVnPlayers.push(audio);

        play.addEventListener('click', function () {
          if (audio.paused) {
            window.luxVnPlayers.forEach(function (other) {
              if (other !== audio && !other.paused) other.pause();
            });
            audio.play();
          } else {
            audio.pause();
          }
        });

        audio.addEventListener('play', function () { card.classList.add('is-playing'); });
        audio.addEventListener('pause', function () { card.classList.remove('is-playing'); });
        audio.addEventListener('ended', function () {
          card.classList.remove('is-playing');
          audio.currentTime = 0;
          progress(0);
          tick();
        });
        audio.addEventListener('timeupdate', tick);
        audio.addEventListener('loadedmetadata', tick);

        wave.addEventListener('click', function (e) {
          if (!isFinite(audio.duration) || audio.duration <= 0) return;
          var r = wave.getBoundingClientRect();
          audio.currentTime = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)) * audio.duration;
          tick();
        });
      }

      if (tbtn && panel) {
        tbtn.addEventListener('click', function () {
          var open = panel.classList.toggle('is-open');
          panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
          tbtn.setAttribute('aria-expanded', open ? 'true' : 'false');
          tbtn.textContent = open ? tbtn.getAttribute('data-label-open') : tbtn.getAttribute('data-label-closed');
        });
      }
    });
  }

  /* ----------------------------------------------------------------------
     12 · Voice Duo — zwei Karten nebeneinander, Player + Wellenform
     Wird von der Section lux-voice-duo und vom Buy-Box-Block "voice_duo"
     genutzt; beide rendern dasselbe Snippet lux-vd-card.
     ---------------------------------------------------------------------- */

  function initVoiceDuo(root) {
    if (root.__luxVd) return;
    root.__luxVd = true;
    root.classList.add('lux-vd--js');

    // Gemeinsames Register mit den uebrigen Playern: es laeuft immer nur eine
    // Aufnahme, egal aus welcher Section oder aus der Buy Box.
    window.luxVnPlayers = window.luxVnPlayers || [];

    function fmt(sec) {
      sec = Math.max(0, Math.floor(sec || 0));
      var m = Math.floor(sec / 60), r = sec % 60;
      return m + ':' + (r < 10 ? '0' : '') + r;
    }

    function mulberry32(a) {
      return function () {
        a |= 0; a = (a + 0x6d2b79f5) | 0;
        var t = Math.imul(a ^ (a >>> 15), 1 | a);
        t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
      };
    }

    // Deterministisch aus dem Seed: gleiche Karte, gleiche Form bei jedem Laden.
    function fakePeaks(n, seed) {
      var rnd = mulberry32(seed * 9781 + 17), out = [];
      for (var i = 0; i < n; i++) {
        var env = 0.42 + 0.58 * Math.abs(Math.sin((i / n) * Math.PI * 2.7 + seed));
        out.push(Math.max(0.12, Math.min(1, (0.32 + 0.68 * rnd()) * env)));
      }
      return out;
    }

    function realPeaks(url, n) {
      var Ctx = window.AudioContext || window.webkitAudioContext;
      if (!Ctx || !window.fetch) return Promise.reject();
      return fetch(url, { mode: 'cors' })
        .then(function (r) { if (!r.ok) throw new Error('http'); return r.arrayBuffer(); })
        .then(function (buf) {
          var ctx = new Ctx();
          return new Promise(function (res, rej) {
            // Safari kennt nur die Callback-Form, neuere Browser geben ein Promise.
            var pr = ctx.decodeAudioData(buf, res, rej);
            if (pr && pr.then) pr.then(res, rej);
          }).then(function (audio) {
            try { ctx.close(); } catch (e) {}
            var data = audio.getChannelData(0);
            var block = Math.max(1, Math.floor(data.length / n));
            var peaks = [], max = 0;
            for (var i = 0; i < n; i++) {
              var sum = 0, count = 0, start = i * block;
              for (var j = 0; j < block; j += 16) {
                var v = data[start + j] || 0;
                sum += v * v; count++;
              }
              var rms = Math.sqrt(sum / Math.max(1, count));
              peaks.push(rms);
              if (rms > max) max = rms;
            }
            return peaks.map(function (v) { return Math.max(0.1, Math.min(1, max ? v / max : 0.5)); });
          });
        });
    }

    function paint(el, vals) {
      var html = '';
      for (var i = 0; i < vals.length; i++) html += '<span style="height:' + (vals[i] * 100).toFixed(1) + '%"></span>';
      el.innerHTML = html;
    }

    $$('[data-lx-vd-card]', root).forEach(function (card, index) {
      var audio = card.querySelector('[data-lx-vd-audio]');
      var play = card.querySelector('[data-lx-vd-play]');
      var wave = card.querySelector('[data-lx-vd-wave]');
      var base = card.querySelector('[data-lx-vd-base]');
      var fill = card.querySelector('[data-lx-vd-fill]');
      var time = card.querySelector('[data-lx-vd-time]');
      var seed = parseInt(card.getAttribute('data-seed') || '1', 10);
      var style = card.getAttribute('data-wave-style') || 'decorative';
      var barW = parseFloat(card.getAttribute('data-bar-width')) || 3;
      var barG = parseFloat(card.getAttribute('data-bar-gap')) || 3;
      var showDur = card.getAttribute('data-show-duration') === '1';
      var url = card.getAttribute('data-audio');
      var realDone = false;
      var lastCount = 0;

      // Balkenzahl aus der tatsaechlichen Breite, nicht fest verdrahtet —
      // so passt die Wellenform bei 165px genauso wie bei 600px.
      // Balkenmasse aus dem berechneten CSS, damit getrennte Mobile-Werte
      // (--vd-bar-w / --vd-bar-gap unter 750px) die Zahl mitfuehren.
      // Die data-Attribute bleiben der Rueckfall.
      function barCount() {
        var cs = window.getComputedStyle(wave);
        var bw = parseFloat(cs.getPropertyValue('--vd-bar-w'));
        var bg = parseFloat(cs.getPropertyValue('--vd-bar-gap'));
        if (!isFinite(bw) || bw <= 0) bw = barW;
        if (!isFinite(bg) || bg < 0) bg = barG;
        var w = wave.getBoundingClientRect().width;
        return Math.max(8, Math.floor(w / (bw + bg)));
      }

      function draw(force) {
        var n = barCount();
        if (!force && n === lastCount) return;
        lastCount = n;
        var vals = fakePeaks(n, seed);
        paint(base, vals);
        paint(fill, vals);
        if (style === 'real' && url && !realDone) {
          realPeaks(url, n).then(function (peaks) {
            realDone = true;
            paint(base, peaks);
            paint(fill, peaks);
          }).catch(function () { /* dekorative Form bleibt stehen */ });
        }
      }

      function progress(ratio) {
        var p = Math.max(0, Math.min(1, ratio || 0));
        fill.style.clipPath = 'inset(0 ' + ((1 - p) * 100).toFixed(2) + '% 0 0)';
      }

      function tick() {
        if (!audio) return;
        var label = fmt(audio.currentTime);
        if (showDur && isFinite(audio.duration) && audio.duration > 0) label += ' / ' + fmt(audio.duration);
        if (time) time.textContent = label;
        if (isFinite(audio.duration) && audio.duration > 0) progress(audio.currentTime / audio.duration);
      }

      if (audio) {
        window.luxVnPlayers.push(audio);
        play.addEventListener('click', function () {
          if (audio.paused) {
            window.luxVnPlayers.forEach(function (other) {
              if (other !== audio && !other.paused) other.pause();
            });
            audio.play();
          } else {
            audio.pause();
          }
        });
        audio.addEventListener('play', function () { card.classList.add('is-playing'); });
        audio.addEventListener('pause', function () { card.classList.remove('is-playing'); });
        audio.addEventListener('ended', function () {
          card.classList.remove('is-playing');
          audio.currentTime = 0;
          progress(0);
          tick();
        });
        audio.addEventListener('timeupdate', tick);
        audio.addEventListener('loadedmetadata', tick);
        wave.addEventListener('click', function (e) {
          if (!isFinite(audio.duration) || audio.duration <= 0) return;
          var r = wave.getBoundingClientRect();
          audio.currentTime = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)) * audio.duration;
          tick();
        });
      }

      // Neu berechnen, wenn sich die Breite aendert — entprellt.
      if ('ResizeObserver' in window) {
        var rt = 0;
        var ro = new ResizeObserver(function () {
          clearTimeout(rt);
          rt = setTimeout(function () { draw(false); }, 120);
        });
        ro.observe(wave);
      }

      function reveal() {
        draw(true);
        // Timer statt requestAnimationFrame: rAF ruht in Hintergrund-Tabs.
        setTimeout(function () {
          card.classList.add('is-revealed');
          card.classList.add('is-drawn');
        }, 30 + index * 90);
      }

      if (reduce || !('IntersectionObserver' in window)) {
        reveal();
      } else {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            reveal();
            io.disconnect();
          });
        }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
        io.observe(card);
      }
    });
  }

  /* ----------------------------------------------------------------------
     Boot — pro Section, auch im Theme-Editor nach jedem Neuladen
     ---------------------------------------------------------------------- */

  function boot(scope) {
    var root = scope || document;
    $$('[data-lx-buybox]', root).forEach(initBuybox);
    $$('[data-lx-voice]', root).forEach(initVoice);
    $$('[data-lx-vd]', root).forEach(initVoiceDuo);
    $$('[data-lx-timeline]', root).forEach(initTimeline);
    $$('[data-lx-word-overlay]', root).forEach(initParallax);
    $$('[data-lx-frequency]', root).forEach(initFrequency);
    $$('[data-lx-section]', root).forEach(initReveal);
    $$('[data-lx-section]', root).forEach(initAudio);
    $$('[data-lx-section]', root).forEach(initVideoDiscipline);
    applyReducedMotionToMedia();
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', function () { boot(); });

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  if (reduce.addEventListener) reduce.addEventListener('change', applyReducedMotionToMedia);
})();
